
<h2 id="page-heading">
  <span>Statistiques :</span>
</h2>
<div class="searchForm flex-row" #myForm id="formMinAnnonce">
    <div class="flex-row">
        <div class="form-row">
          <div class="col-2">
              <ng-select class="mb-2" [ngModelOptions]="{standalone: true}"
              dropdownPosition='bottom' placeholder="Perimètre" (change) = "perimetreChange()"
                [items]="targetTypes" [multiple]="false"
                [bindLabel]="'label'" (change)="getTargets(false)"
                [closeOnSelect]="true" bindValue="code" [(ngModel)]="selectedTargetType"
                name="targetTypes">
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/> {{item.label}}
              </ng-template>
              </ng-select>
          </div>
          <div class="col-3">
            <ng-select class="mb-2" 
            dropdownPosition='bottom' placeholder="Element"
              [items]="targets" [multiple]="true"
              [bindLabel]="'label'"
              [closeOnSelect]="false" bindValue="id"  [formControl]="selectedTarget"
              name="selectTargets">
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="item-{{index}}" type="checkbox" [(ngModel)]="item$.selected"/> {{item.label}}
            </ng-template>
            </ng-select>
          </div>
          <div class="col-2">
            <ng-select class="mb-2" [ngModelOptions]="{standalone: true}"
            dropdownPosition='bottom' placeholder="Unité"
              [items]="units" [multiple]="false"
              [bindLabel]="'label'"
              [closeOnSelect]="true" bindValue="code" [(ngModel)]="selectedUnite"
              name="selectUnit">
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/> {{item.label}}
            </ng-template>
            </ng-select>
          </div>
          <div class="form-inline col-auto  mb-2 formGroup">
            <mat-form-field class="form-control" >
              <mat-date-range-input  [formGroup]="dateRange" [rangePicker]="picker" >
                <input matStartDate formControlName="start" placeholder="Date début" >
                <input matEndDate formControlName="end" placeholder="Date fin" >
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            
              <mat-error *ngIf="dateRange.controls.start.hasError('matStartDateInvalid')">date début invalide</mat-error>
              <mat-error *ngIf="dateRange.controls.end.hasError('matEndDateInvalid')">date fin invalide</mat-error>
            </mat-form-field>
          </div>
          <div class="col my-1">
            <button id="create-variable" class="btn btn-indigo float-right" type="submit" (click)="rechercher()">
              <span>
                Rechercher
              </span>
            </button>
          </div>
        </div>
    </div>
</div>
